import React, { Component } from 'react';
import { Table, Tooltip, Icon, message } from 'antd';
import { PersonalFilter as Filter } from './SearchFilter';
import { PersonalView as View } from './EfficiencyView';
import ExportUtil from '../../../common/ExportUtil';
import EfficiencyTotal from './EfficiencyTotal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import VacantModal from './VacantModal';
import PortalExport from './PortalExport';

class Personal extends Component {
    state = {
        visible: false,
        sortParams: {},
        searchParams: {},
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { userId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryPortalUserEfficiency,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                crcUserId: userId,
                relatedUser: 0,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            }
        }
        $.sendRequest(options);
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
        }
        this.portalExportRef.show();
        // this.addToDownloadSite(params, API_URL.user.exportPortalUserEfficiency, 'Personal_Efficiency');
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        return (
            [{
                title: '时间',
                dataIndex: 'time',
                key: 'time',
                fixed: 'left',
                width: 80
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                fixed: 'left',
                width: 80
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                fixed: 'left',
                width: 80
            }, {
                title: '状态',
                dataIndex: 'workStatus',
                key: 'workStatus',
                width: 80
            }, {
                title: '职位',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 80
            }, {
                title: '主管领导',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 100
            }, {
                title: '区域',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 80
            }, {
                title: '工作城市',
                dataIndex: 'workCity',
                key: 'workCity',
                width: 100
            }, {
                title: '当月项目计划FTE',
                dataIndex: 'planFte',
                key: 'planFte',
                width: 130,
            }, {
                title: '当月项目消耗FTE',
                dataIndex: 'consumeFte',
                key: 'consumeFte',
                width: 130,
            }, {
                title: '当月筛选数',
                dataIndex: 'filterCount',
                key: 'filterCount',
                width: 130,
            }, {
                title: '累计筛选数',
                dataIndex: 'totalFilterCount',
                key: 'totalFilterCount',
                width: 130,
            }, {
                title: '当月随机数',
                dataIndex: 'randomCount',
                key: 'randomCount',
                width: 130,
            }, {
                title: '累计随机数',
                dataIndex: 'totalRandomCount',
                key: 'totalRandomCount',
                width: 130,
            }, {
                title: '当月完成访视数',
                dataIndex: 'visitCount',
                key: 'visitCount',
                width: 130,
            }, {
                title: '累计完成访视数',
                dataIndex: 'totalVisitCount',
                key: 'totalVisitCount',
                width: 130,
            }, {
                title: '当月CRC项目确认FTE',
                dataIndex: 'monthCrcFte',
                key: 'monthCrcFte',
                width: 90,
            }, {
                title: '当月确认标准访视数',
                dataIndex: 'monthStandardVisitCount',
                key: 'monthStandardVisitCount',
                width: 90,
            }, {
                title: '累计确认标准访视数',
                dataIndex: 'standardVisitCount',
                key: 'standardVisitCount',
                width: 90,
            }, {
                title: (
                    <span>
                        当月CRC访视效率比
                        <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'当月CRC访视效率比=当月确认标准访视数/当月CRC项目确认FTE'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'visitRate',
                key: 'visitRate',
                width: 150,
            }, {
                title: '中心CRC项目确认FTE',
                dataIndex: 'siteMonthCrcFte',
                key: 'siteMonthCrcFte',
                width: 110,
            }, {
                title: '中心当月确认标准访视数',
                dataIndex: 'siteMonthStandardVisitCount',
                key: 'siteMonthStandardVisitCount',
                width: 110,
            }, {
                title: (
                    <span>
                        中心访视效率比
                        <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'中心当月访视效率比=中心当月确认标准访视数/中心当月CRC项目确认FTE'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'siteVisitRate',
                key: 'siteVisitRate',
                width: 110,
            }, {
                title: '当月重大事件数',
                dataIndex: 'majorEventNum',
                key: 'majorEventNum',
                width: 110,
            }, {
                title: '累计重大事件数',
                dataIndex: 'majorEventNumTotal',
                key: 'majorEventNumTotal',
                width: 110,
            }, {
                title: (
                    <span>
                        当月月空余率
                        <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'个人月空余率=(1-(该月个人项目确认FTE/(该月个人工作周期/(该月工作日*8))))*100%【若值小于0，取0】'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'spareRate',
                key: 'spareRate',
                width: 130
            }, {
                title: '当月月空余主因素',
                dataIndex: 'mainVacantRateFactor',
                key: 'mainVacantRateFactor',
                width: 110,
            }, {
                title: '空余率-非项目因素',
                dataIndex: 'vacantRateNonInvFactor',
                key: 'vacantRateNonInvFactor',
                width: 120,
                render: (text, record) => {
                    const { nonInvFactorCanClick } = record;
                    return nonInvFactorCanClick == true ? <a onClick={() => this.showVacantModal(record, 'factorNonInv')}>{text}</a> : text
                }
            }, {
                title: '空余率-项目因素',
                dataIndex: 'vacantRateInvFactor',
                key: 'vacantRateInvFactor',
                width: 110,
                render: (text, record) => {
                    const { invFactorCanClick } = record;
                    return invFactorCanClick == true ? <a onClick={() => this.showVacantModal(record, 'factorInv')}>{text}</a> : text
                }
            }, {
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: "right",
                width: 150,
                render: (text, record, index) => {
                    const { userId, employeeCode } = record;
                    return (
                        <div>
                            {
                                employeeCode !== '总计' &&
                                <span>
                                    <a onClick={() => this.showView(record)}>查看明细</a>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.showTotal(userId)}>效率统计</a>
                                </span>
                            }
                        </div>
                    )
                }
            }]
        )
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;

        const dataSource = data.map((item, index) => {
            if (item.investigationCode != '总计') {
                return {
                    index: ((current - 1) || 0) * pageSize + index + 1,
                    ...item,
                    planFte: item.planFte.toFixed(2),
                    spareRate: item.spareRate.toFixed(2),
                    consumeFte: item.consumeFte.toFixed(2),
                };
            } else if (item.investigationCode == '总计') {
                return {
                    index: item.investigationCode,
                    ...item,
                    planFte: item.planFte.toFixed(2),
                    spareRate: item.spareRate.toFixed(2),
                    consumeFte: item.consumeFte.toFixed(2),
                };
            }
        });
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field == 'time' ? 'date' : sorter.field;
        sortParams.direction = sorter.order ? sorter.order === 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    showView = record => {
        this.viewRef.show(record);
    }

    showTotal = id => {
        this.totalRef.show(id);
    }

    showVacantModal = (record, type) => {
        this.vacantModalRef.show(record, type);
    }

    render() {
        const { loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.index}
                    loading={loading}
                    scroll={{ x: 2530 }}
                    onChange={this.handleTableChange}
                    pagination={pagination}
                />
                <View ref={el => this.viewRef = el} />
                <EfficiencyTotal ref={el => this.totalRef = el} />
                <VacantModal ref={el => this.vacantModalRef = el} />
                <PortalExport ref={el => this.portalExportRef = el} searchParams={searchParams} sortParams={sortParams} />
            </div>
        );
    }
}

export default Personal;


// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/Personal.js